export default __webpack_public_path__ + "static/media/box-4.2ec7c320.png";